import { useMemo } from 'react';

import { storeKeys, useGetCart } from '@givebacks/api/store';
import { useQueries } from '@tanstack/react-query';

import { useCartStorage } from '../hooks/useCartStorage';

/** Gets all carts currently in local storage */
const useGetUserShopCarts = () => {
  const { getCartsByStore } = useCartStorage();
  const _carts = useMemo(() => getCartsByStore({ orderBy: 'lastModified' }), [getCartsByStore]);

  const getCart = useGetCart();

  return useQueries({
    queries: _carts.map((cart) => {
      return {
        queryKey: storeKeys.id('user').carts.id(cart.cart.cartId).detail,
        queryFn: () => getCart({ cartId: cart.cart.cartId, causeId: cart.storeId }),
      };
    }),
  });
};

/** Provides query-like interface to useGetUserShopCarts */
const useUserShopCarts = () => {
  const cartsData = useGetUserShopCarts();
  const isLoading = useMemo(() => cartsData.some((response) => response.isLoading), [cartsData]);
  const isFetching = useMemo(() => cartsData.some((response) => response.isFetching), [cartsData]);

  return {
    carts: useMemo(() => cartsData.map((response) => response.data), [cartsData]),
    isLoading,
    isFetching,
    responses: cartsData,
  };
};

export { useUserShopCarts };
